// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2rlm8","index":"styles_index__6vAt8"};